'use client';
import Button from '@/components/Button';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useTranslations } from '@/i18n/use-translations';

import { useRouter } from 'next/navigation';

const HowItWorks = ({
  memberPrivileges,
  showBtn,
  SDRewardsPageBtnClick,
}: {
  memberPrivileges: any;
  showBtn?: boolean;
  SDRewardsPageBtnClick: (btnName: string) => void;
}) => {
  const router = useRouter();
  const t = useTranslations('zeeloolRewards.howItWorks');
  const { work_desc } = memberPrivileges;
  if (!work_desc) return null;

  function handleLearnMore() {
    SDRewardsPageBtnClick('Learn More');
    router.push('/zeelool-rewards');
  }

  return (
    <>
      <WebOnly>
        <div className="bg-white pt-[80px]">
          <div className="mx-auto max-w-[1200px] text-center">
            <h2 className="mb-[40px] text-[32px] font-bb">{work_desc.title}</h2>
            <div className="flex justify-around gap-5">
              {work_desc.info?.map((item: any) => (
                <div key={item.title} className="flex-1 px-5">
                  <h3 className="mb-8 text-20 font-bb">{item.title}</h3>
                  <p className="font-br text-16 leading-normal text-[#808080]">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>

            {showBtn && (
              <div className="mt-40">
                <Button
                  color="black"
                  variant="contained"
                  radiusSize="large"
                  onClick={() => handleLearnMore()}
                  className="w-[240px] h-[40px] rounded-20 !bg-[#282828] text-white !text-14"
                >
                  {t('learnMore')}
                </Button>
              </div>
            )}
          </div>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="bg-white pt-[52px]">
          <div className="mx-auto text-center">
            <h2 className="mb-[32px] text-[24px] leading-[29px] font-bb">{work_desc.title}</h2>
            <div className="flex flex-col justify-around gap-32">
              {work_desc.info?.map((item: any) => (
                <div key={item.title} className="flex-1 px-32">
                  <h3 className="mb-8 text-16 leading-[20px] font-bb">{item.title}</h3>
                  <p className="font-br text-[13px] leading-[16px] text-[#808080]">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>

            {showBtn && (
              <div className="mt-40">
                <Button
                  className="w-[240px] h-[36px] rounded-12 !bg-[#282828] text-white !text-14"
                  color="black"
                  variant="contained"
                  radiusSize="large"
                  onClick={() => handleLearnMore()}
                >
                  {t('learnMore')}
                </Button>
              </div>
            )}
          </div>
        </div>
      </WapOnly>
    </>
  );
};

export default HowItWorks;
